// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const fetchUserPreferences = createAction('[Custom PDF Report Modal] Fetch User Preferences');
export const setCoverPageInfo = createAction('[Custom PDF Report Modal] Set Cover Page Info', props());
export const setCoverPageInfoFailure = createAction('[Custom PDF Report Modal] Failed Setting Cover Page Info');
export const setUserPreferencesFetchSuccess = createAction('[Custom PDF Report Modal] Succeeded Fetching User Preferences', props());
export const setUserPreferencesFetchFailure = createAction('[Custom PDF Report Modal] Failed Fetching User Preferences');
